import type { MfaAuthenticator } from "react-native-auth0";

const findAuthenticator = ({
  authenticators,
  oobChannel,
}: {
  authenticators?: MfaAuthenticator[];
  oobChannel: "email" | "sms";
}) => {
  return authenticators?.find((a) => a.active && a.oobChannel === oobChannel);
};

const getPreferredAuthenticator = (
  authenticators?: MfaAuthenticator[],
): MfaAuthenticator | undefined => {
  const smsAuthenticator = findAuthenticator({
    authenticators,
    oobChannel: "sms",
  });
  const emailAuthenticator = findAuthenticator({
    authenticators,
    oobChannel: "email",
  });
  return smsAuthenticator ?? emailAuthenticator;
};

export { findAuthenticator, getPreferredAuthenticator };
